import { createContext } from 'react';
import type { Toast } from './Provider';

type ToastContextValue = {
    addToast: (toast: Omit<Toast, 'id' | 'timer'>) => void;
    removeToast: (id: string) => void;
};

const ToastContext = createContext<ToastContextValue>({
    addToast: () => {},
    removeToast: () => {},
});

export default ToastContext;
